let playerConfig = {
  type: "player",
  count: 1,
  x: 200,
  y: 100,
};
module.exports = playerConfig;
